import React, { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
// import thumbnailImg from '../../assets/images/landingpage/Hero-thumbnail.avif';
import { Link } from 'react-router-dom';
import * as Icons from '../../common/icons/homePageIcons';

const HeaderBanner = (props) => {
    const bannerData = props?.data;
    const bannerBgImg = props?.bannerImg;
    const Icon = Icons[bannerData?.btnIcon] || null;
    function myFunction() {
        document.getElementById("mp4_src").src = bannerBgImg;
        document.getElementById("myVideo").load();
    }
    useEffect(() => {
        myFunction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="static-slider-head">
            <video id="myVideo" loop muted autoPlay preload="metadata" poster={'/assets/images/landingpage/Hero-thumbnail.avif'} className='w-100'>
                <source id="mp4_src" src={bannerBgImg} type="video/mp4" />
                {/* <source id="ogg_src" src="mov_bbb.ogg" type="video/ogg" /> */}
                Your browser does not support HTML5 video.
            </video>
            <Container className="static-container">
                <Row className="justify-content-start">
                    <Col lg="8" md="6" className="align-self-start">
                        <h1>{bannerData?.title} <span>{bannerData?.subTitle}</span> {bannerData?.subTitle2}</h1>
                        <p>{bannerData?.text}</p>
                        <Link to={bannerData?.link} className="btn btn-md m-t-30 btn-info-gradiant font-14 rounded-5">
                            {bannerData?.btnName} {Icon && <Icon />}
                        </Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default HeaderBanner;
